import { CREATE_DMX_PROFILE, CREATE_DMX_PROFILE_SUCCESSFUL, CREATE_DMX_PROFILE_FAILED } from './actionTypes';

export const createDmxProfile = (profile) => {
  return {
    type: CREATE_DMX_PROFILE,
    payload: { profile },
  };
};

export const createDmxProfileSuccessful = (message) => {
  return {
    type: CREATE_DMX_PROFILE_SUCCESSFUL,
    payload: message,
  };
};

export const createDmxProfileFailed = (message) => {
  return {
    type: CREATE_DMX_PROFILE_FAILED,
    payload: message,
  };
};
